module.exports = __webpack_public_path__ + "img/KALIN.d8051afd.png";